import { render, staticRenderFns } from "./AcademicProgressInform.vue?vue&type=template&id=1dfce01a&scoped=true&"
import script from "./AcademicProgressInform.vue?vue&type=script&lang=js&"
export * from "./AcademicProgressInform.vue?vue&type=script&lang=js&"
import style0 from "./AcademicProgressInform.vue?vue&type=style&index=0&id=1dfce01a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dfce01a",
  null
  
)

export default component.exports